import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ManagedEntitiesConnection,
  PageInfo,
  QuerySearchManagedEntitiesArgs,
  Stack,
} from "types/generated";

const SEARCH_MANAGED_ENTITIES_FRAGMENT = gql`
  fragment SearchManagedEntitiesFragment on SearchManagedEntitiesOutput {
    edges {
      cursor
      node {
        id
        address
        creator {
          id
          title
          updatedAt
        }
        drifted
        name
        parent
        stackId
        stackName
        stackVendor
        thirdPartyMetadata
        type
        updater {
          id
          title
          updatedAt
        }
        vendor {
          ... on EntityVendorAnsible {
            ansible {
              ... on AnsibleResource {
                __typename
              }
            }
          }
          ... on EntityVendorTerraform {
            terraform {
              ... on TerraformResource {
                module
                address
                provider
                tainted
                values
              }
              ... on TerraformOutput {
                hash
                sensitive
                value
              }
              ... on TerraformModule {
                __typename
              }
            }
          }
          ... on EntityVendorCloudFormation {
            cloudFormation {
              ... on CloudFormationResource {
                logicalResourceId
                physicalResourceId
                template
              }
            }
          }
          ... on EntityVendorKubernetes {
            kubernetes {
              ... on KubernetesResource {
                data
              }
            }
          }
          ... on EntityVendorPulumi {
            pulumi {
              ... on PulumiResource {
                urn
                id
                provider
                parent
                outputs
              }
              ... on PulumiOutput {
                hash
                sensitive
                value
              }
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
    }
  }
`;

export type SearchManagedEntitiesData = {
  searchManagedEntities: {
    edges: Array<ManagedEntitiesConnection>;
    pageInfo: Pick<PageInfo, "endCursor" | "startCursor" | "hasNextPage">;
  };
};

export const SEARCH_MANAGED_ENTITIES: TypedDocumentNode<
  SearchManagedEntitiesData,
  QuerySearchManagedEntitiesArgs
> = gql`
  query SearchManagedEntities($input: SearchInput!) {
    searchManagedEntities(input: $input) {
      ...SearchManagedEntitiesFragment
    }
  }
  ${SEARCH_MANAGED_ENTITIES_FRAGMENT}
`;

export type SearchStackManagedEntitiesData = {
  stack: Pick<Stack, "id"> & SearchManagedEntitiesData;
};

export const SEARCH_STACK_MANAGED_ENTITIES: TypedDocumentNode<
  SearchStackManagedEntitiesData,
  QuerySearchManagedEntitiesArgs
> = gql`
  query SearchStackManagedEntities($stackId: ID!, $input: SearchInput!) {
    stack(id: $stackId) {
      id
      searchManagedEntities(input: $input) {
        ...SearchManagedEntitiesFragment
      }
    }
  }
  ${SEARCH_MANAGED_ENTITIES_FRAGMENT}
`;
